
function toDate(timeStr) {
  if (timeStr == undefined) {
    return undefined
  }
  let dateObj = new Date()

  // eslint-disable-next-line
  let [ hour, minute, second ] = timeStr.split(':')
  dateObj.setHours(parseInt(hour))
  dateObj.setMinutes(parseInt(minute))
  dateObj.setSeconds(0)
  dateObj.setMilliseconds(0)
  return dateObj
}

function toInputField(timeStr) {
  if (timeStr == undefined) {
    return undefined
  }

  // eslint-disable-next-line
  let [ hour, minute, second ] = timeStr.split(':')
  return `${hour}:${minute}`
}

function formatAMPM(timeStr) {
  if (timeStr == null) {
    return '--'
  }
  // eslint-disable-next-line
  let [ hour, minute, second ] = timeStr.split(':')
  hour = parseInt(hour)
  return `${(hour + 11) % 12 + 1}:${minute} ${(hour < 12) ? 'AM' : 'PM'}`
}

function today(offset) {
  if (!offset) {
    offset = 0
  }
  const today = new Date()
  today.setDate(today.getDate() + offset)
  return today.toISOString().slice(0, 10)
}

function compareToToday(dateObj) {
  return today() === dateObj.toISOString().slice(0, 10)
}

function getDateAtWeekday(weekdayIndex, startDate = undefined) {
  if (startDate === undefined) {
    startDate = new Date()
  }
  let offset = weekdayIndex - startDate.getDay()
  startDate.setDate(startDate.getDate() + offset)
  return startDate.toISOString().slice(0, 10)
}

function timeToDisplay(time) {
  const sections = time.split(':')
  const hours = sections[0]
  const minutes = sections[1]
  if (Number(hours) > 12) {
    return `${Number(hours) % 12}:${minutes} PM`
  } else if (Number(hours) === 12) {
    return `${Number(hours)}:${minutes} PM`
  } else if (Number(hours) === 0) {
    return `12:${minutes} AM`
  } else {
    return `${Number(hours)}:${minutes} AM`
  }
}

export default {
  toDate,
  toInputField,
  formatAMPM,
  today,
  compareToToday,
  getDateAtWeekday,
  timeToDisplay,
}
